import { Place } from "@mui/icons-material";
import React from "react";
import { Coordinate, Overlay } from "rousen-react";

interface Props {
  coordinate: Coordinate;
  color: "primary" | "secondary";
}

const Marker = ({ coordinate, color }: Props) => {
  return (
    <Overlay lat={Number(coordinate.lat)} lon={Number(coordinate.lon)}>
      <Place color={color} fontSize="large" />
    </Overlay>
  );
};

export default Marker;
